export default __webpack_public_path__ + "static/pict6-35060bd5fd01650ec35662ebfac19a7c.png";